import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_2 = { class: "mb-6 flex items-center gap-3" }
const _hoisted_3 = { class: "p-2 bg-[#22282F]/10 rounded-lg" }
const _hoisted_4 = {
  key: 0,
  class: "mb-4 text-sm bg-amber-50 border border-amber-200 text-amber-800 rounded-lg px-3 py-2"
}
const _hoisted_5 = {
  key: 1,
  class: "py-16 text-center text-gray-400"
}
const _hoisted_6 = {
  key: 2,
  class: "py-16 text-center text-red-500"
}
const _hoisted_7 = {
  key: 3,
  class: "grid grid-cols-1 lg:grid-cols-[18rem_1fr] gap-6 items-start"
}
const _hoisted_8 = { class: "bg-white rounded-xl border border-gray-200 overflow-hidden" }
const _hoisted_9 = { class: "p-3 border-b border-gray-100" }
const _hoisted_10 = { class: "max-h-[70vh] overflow-y-auto divide-y divide-gray-100" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex items-center justify-between gap-2" }
const _hoisted_13 = { class: "font-semibold text-sm text-gray-900 truncate" }
const _hoisted_14 = { class: "text-xs text-gray-400 shrink-0" }
const _hoisted_15 = { class: "text-xs text-gray-500 font-mono truncate" }
const _hoisted_16 = { class: "text-xs text-gray-400 mt-0.5" }
const _hoisted_17 = {
  key: 0,
  class: "px-4 py-8 text-center text-sm text-gray-400"
}
const _hoisted_18 = {
  key: 0,
  class: "bg-white rounded-xl border border-gray-200"
}
const _hoisted_19 = { class: "px-5 pt-4 flex flex-wrap items-center gap-3 border-b border-gray-100" }
const _hoisted_20 = { class: "flex-1 min-w-0 pb-3" }
const _hoisted_21 = { class: "text-lg font-bold text-gray-900 truncate" }
const _hoisted_22 = { class: "text-xs font-mono text-gray-500" }
const _hoisted_23 = { class: "flex gap-1" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "p-5" }
const _hoisted_26 = {
  key: 0,
  class: "space-y-5 max-w-2xl"
}
const _hoisted_27 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_28 = { class: "sm:col-span-2" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "sm:col-span-2" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["onUpdate:modelValue", "disabled"]
const _hoisted_35 = { class: "text-sm font-medium text-gray-800" }
const _hoisted_36 = { class: "block text-xs text-gray-500" }
const _hoisted_37 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_38 = { class: "text-sm text-gray-600 flex items-start gap-2" }
const _hoisted_39 = { class: "text-xs font-bold uppercase tracking-wide text-gray-500 mb-2" }
const _hoisted_40 = { class: "border border-gray-200 rounded-lg divide-y divide-gray-100" }
const _hoisted_41 = ["checked", "disabled", "onChange"]
const _hoisted_42 = { class: "flex-1 min-w-[14rem]" }
const _hoisted_43 = { class: "text-sm font-medium text-gray-800" }
const _hoisted_44 = { class: "text-xs text-gray-500" }
const _hoisted_45 = ["onUpdate:modelValue", "disabled"]
const _hoisted_46 = ["value"]
const _hoisted_47 = {
  key: 2,
  class: "space-y-4"
}
const _hoisted_48 = {
  key: 0,
  class: "text-sm bg-amber-50 border border-amber-200 text-amber-800 rounded-lg px-3 py-2 flex gap-2"
}
const _hoisted_49 = { class: "text-sm text-gray-600 flex items-start gap-2" }
const _hoisted_50 = {
  key: 1,
  class: "overflow-x-auto border border-gray-200 rounded-lg"
}
const _hoisted_51 = { class: "w-full text-sm" }
const _hoisted_52 = { class: "px-3 py-2 font-semibold text-gray-500" }
const _hoisted_53 = { class: "px-3 py-2" }
const _hoisted_54 = ["onUpdate:modelValue", "disabled"]
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "px-3 py-2" }
const _hoisted_57 = ["onUpdate:modelValue", "disabled"]
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "px-3 py-2 text-center" }
const _hoisted_60 = ["onUpdate:modelValue", "disabled"]
const _hoisted_61 = { class: "px-3 py-2 text-center" }
const _hoisted_62 = ["onUpdate:modelValue", "disabled"]
const _hoisted_63 = { class: "px-3 py-2" }
const _hoisted_64 = ["onUpdate:modelValue", "disabled"]
const _hoisted_65 = { class: "px-3 py-2 text-right whitespace-nowrap" }
const _hoisted_66 = ["onClick", "disabled"]
const _hoisted_67 = ["onClick", "disabled"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 2,
  class: "py-8 text-center text-sm text-gray-400 border border-dashed border-gray-300 rounded-lg"
}
const _hoisted_70 = {
  key: 3,
  class: "flex flex-wrap gap-2"
}
const _hoisted_71 = {
  key: 3,
  class: "space-y-4"
}
const _hoisted_72 = { class: "text-sm text-gray-600 flex items-start gap-2" }
const _hoisted_73 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_74 = { class: "text-sm font-semibold text-gray-800 mb-2" }
const _hoisted_75 = { class: "text-sm text-gray-700 mb-3 space-y-0.5" }
const _hoisted_76 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_77 = { class: "text-sm text-gray-700 space-y-0.5" }
const _hoisted_78 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_79 = {
  key: 0,
  class: "px-5 py-3 border-t border-gray-100 flex flex-wrap items-center gap-3 bg-gray-50 rounded-b-xl"
}
const _hoisted_80 = ["disabled"]
const _hoisted_81 = {
  key: 0,
  class: "text-xs text-amber-700"
}
const _hoisted_82 = {
  key: 1,
  class: "text-emerald-600 text-sm flex items-center gap-1"
}
const _hoisted_83 = {
  key: 2,
  class: "text-red-500 text-sm"
}
const _hoisted_84 = {
  key: 1,
  class: "bg-white rounded-xl border border-dashed border-gray-300 py-20 text-center text-gray-400"
}
const _hoisted_85 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_86 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_87 = { class: "flex justify-end gap-2 pt-2" }

import { ref, computed, reactive, onMounted } from 'vue'
import { KeyRound, Plus, Trash2, ArrowUp, ArrowDown, Check, Info, Eye, AlertTriangle } from 'lucide-vue-next'
import AdminLayout from '@/layouts/AdminLayout.vue'
import { apiFetch } from '@/utils/apiFetch'

interface Capacite { key: string; label: string; description: string; category: string; portee: 'serveur' | 'interface' }
interface Option { value: string; label: string }
interface Drapeau { key: string; label: string; description: string }
interface Catalogue { capacites: Capacite[]; conditions: Option[]; scopes: Option[]; drapeaux: Drapeau[] }
interface Resume {
  id: number; code: string; nom: string; niveau_hierarchique: number; rang_circuit: number | null
  nb_utilisateurs: number; nb_capacites: number; nb_etapes_circuit: number
}
interface Etape {
  ordre?: number; step_role_id: number; scope: string
  requires_paraphe: boolean; requires_signature: boolean; label: string
}
interface Apercu { pages: { key: string; label: string }[]; capacites: string[] }
interface Fiche extends Resume {
  description: string
  circuit: Etape[]
  capacites: { capability: string; condition: string }[]
  circuit_historique: boolean
  apercu: Record<string, Apercu>
  can_edit: boolean
  [drapeau: string]: unknown
}
interface Brouillon {
  code: string; nom: string; niveau_hierarchique: number; rang_circuit: number | null; description: string
  drapeaux: Record<string, boolean>
  capacites: Record<string, string>
  circuit: Etape[]
  circuit_historique: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RolesView',
  setup(__props) {

const onglets = [
  { id: 'general', label: 'Général' },
  { id: 'capacites', label: 'Capacités' },
  { id: 'circuit', label: 'Circuit' },
  { id: 'apercu', label: 'Aperçu' },
]

const catalogue = reactive<Catalogue>({ capacites: [], conditions: [], scopes: [], drapeaux: [] })
const roles = ref<Resume[]>([])
const canEdit = ref(false)
const chargement = ref(false)
const erreurChargement = ref<string | null>(null)
const recherche = ref('')
const selectionId = ref<number | null>(null)
const fiche = ref<Fiche | null>(null)
const brouillon = ref<Brouillon | null>(null)
const instantane = ref('')
const onglet = ref('general')
const enregistrement = ref(false)
const message = ref<string | null>(null)
const erreur = ref<string | null>(null)
const creation = ref<{ code: string; nom: string; niveau_hierarchique: number | null; rang_circuit: number | null } | null>(null)
const erreurCreation = ref<string | null>(null)

const rolesFiltres = computed(() => {
  const q = recherche.value.trim().toLowerCase()
  return q ? roles.value.filter((r) => r.nom.toLowerCase().includes(q) || r.code.toLowerCase().includes(q)) : roles.value
})

const groupes = computed(() => {
  const parCategorie = new Map<string, Capacite[]>()
  for (const c of catalogue.capacites) {
    if (!parCategorie.has(c.category)) parCategorie.set(c.category, [])
    parCategorie.get(c.category)!.push(c)
  }
  return Array.from(parCategorie.entries()).map(([categorie, capacites]) => ({ categorie, capacites }))
})

const apercuCartes = computed(() => {
  const a = fiche.value?.apercu
  if (!a) return []
  return [
    { cle: 'sans_rattachement', titre: 'Sans rattachement', ...a.sans_rattachement },
    { cle: 'avec_direction', titre: 'Rattaché à une direction', ...a.avec_direction },
    { cle: 'avec_ambassade', titre: 'Rattaché à une ambassade', ...a.avec_ambassade },
  ]
})

const libelle = (cle: string) => catalogue.capacites.find((c) => c.key === cle)?.label ?? cle

// Ce qui part au serveur : sert aussi à savoir si quelque chose a changé.
const charge = (b: Brouillon) => ({
  nom: b.nom, niveau_hierarchique: b.niveau_hierarchique, rang_circuit: b.rang_circuit ?? null,
  description: b.description, ...b.drapeaux,
  capacites: Object.entries(b.capacites).map(([capability, condition]) => ({ capability, condition })),
  circuit: b.circuit.map((e, i) => ({
    ordre: i + 1, step_role_id: e.step_role_id, scope: e.scope,
    requires_paraphe: e.requires_paraphe, requires_signature: e.requires_signature, label: e.label || '',
  })),
})
const modifie = computed(() => !!brouillon.value && JSON.stringify(charge(brouillon.value)) !== instantane.value)

function depuisFiche(f: Fiche): Brouillon {
  return {
    code: f.code, nom: f.nom, niveau_hierarchique: f.niveau_hierarchique, rang_circuit: f.rang_circuit,
    description: f.description || '',
    drapeaux: Object.fromEntries(catalogue.drapeaux.map((d) => [d.key, Boolean(f[d.key])])),
    capacites: Object.fromEntries(f.capacites.map((c) => [c.capability, c.condition || ''])),
    circuit: f.circuit.map((e) => ({ ...e })),
    circuit_historique: f.circuit_historique,
  }
}

function poser(f: Fiche) {
  fiche.value = f
  brouillon.value = depuisFiche(f)
  instantane.value = JSON.stringify(charge(brouillon.value))
}

async function chargerListe() {
  const data = await apiFetch<{ roles: Resume[]; can_edit: boolean }>('/api/admin/role-engine/roles/')
  roles.value = data.roles
  canEdit.value = data.can_edit
}

async function choisir(id: number) {
  if (id === selectionId.value) return
  if (modifie.value && !window.confirm('Des modifications ne sont pas enregistrées. Les abandonner ?')) return
  message.value = erreur.value = null
  selectionId.value = id
  try {
    poser(await apiFetch<Fiche>(`/api/admin/role-engine/roles/${id}/`))
  } catch (e) {
    erreur.value = e instanceof Error ? e.message : 'Erreur de chargement.'
  }
}

function basculerCapacite(cle: string, accordee: boolean) {
  if (!brouillon.value) return
  if (accordee) brouillon.value.capacites[cle] = ''
  else delete brouillon.value.capacites[cle]
}

function ajouterEtape(scope: string) {
  if (!brouillon.value || !fiche.value) return
  const parDefaut = scope === 'self' ? fiche.value.id : roles.value.find((r) => r.code === (scope === 'national' ? 'SG' : 'CHEF_SERVICE'))?.id ?? fiche.value.id
  brouillon.value.circuit.push({ step_role_id: parDefaut, scope, requires_paraphe: true, requires_signature: false, label: '' })
}

function deplacer(i: number, sens: number) {
  const c = brouillon.value?.circuit
  if (!c) return
  const [e] = c.splice(i, 1)
  c.splice(i + sens, 0, e)
}

async function enregistrer() {
  if (!brouillon.value || selectionId.value === null) return
  enregistrement.value = true
  message.value = erreur.value = null
  try {
    const f = await apiFetch<Fiche>(`/api/admin/role-engine/roles/${selectionId.value}/`, {
      method: 'PUT', body: JSON.stringify(charge(brouillon.value)),
    })
    poser(f)
    await chargerListe()
    message.value = 'Enregistré'
    setTimeout(() => { message.value = null }, 3000)
  } catch (e) {
    erreur.value = e instanceof Error ? e.message : "Échec de l'enregistrement."
  } finally {
    enregistrement.value = false
  }
}

function ouvrirCreation() {
  erreurCreation.value = null
  creation.value = { code: '', nom: '', niveau_hierarchique: null, rang_circuit: null }
}

async function creer() {
  if (!creation.value) return
  erreurCreation.value = null
  try {
    const f = await apiFetch<Fiche>('/api/admin/role-engine/roles/', {
      method: 'POST',
      body: JSON.stringify({ ...creation.value, code: creation.value.code.trim().toUpperCase() }),
    })
    creation.value = null
    await chargerListe()
    selectionId.value = f.id
    poser(f)
    onglet.value = 'capacites'
  } catch (e) {
    erreurCreation.value = e instanceof Error ? e.message : 'Échec de la création.'
  }
}

onMounted(async () => {
  chargement.value = true
  try {
    Object.assign(catalogue, await apiFetch<Catalogue>('/api/admin/role-engine/catalogue/'))
    await chargerListe()
  } catch (e) {
    erreurChargement.value = e instanceof Error ? e.message : 'Erreur de chargement.'
  } finally {
    chargement.value = false
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(KeyRound), { class: "w-7 h-7 text-[#22282F]" })
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex-1" }, [
            _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-gray-900" }, "Rôles et droits"),
            _createElementVNode("p", { class: "text-sm text-gray-500" }, " Créez un rôle et réglez ce qu'il voit et ce qu'il peut faire, sans toucher au code. ")
          ], -1)),
          (canEdit.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: ouvrirCreation,
                class: "px-4 py-2 bg-[#22282F] text-white rounded-lg text-sm hover:opacity-90 flex items-center gap-2"
              }, [
                _createVNode(_unref(Plus), { class: "w-4 h-4" }),
                _cache[14] || (_cache[14] = _createTextVNode(" Nouveau rôle "))
              ]))
            : _createCommentVNode("", true)
        ]),
        (!canEdit.value && !chargement.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Lecture seule : seul l'administrateur global peut modifier les rôles et leurs droits. "))
          : _createCommentVNode("", true),
        (chargement.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Chargement…"))
          : (erreurChargement.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(erreurChargement.value), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("aside", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recherche).value = $event)),
                      type: "search",
                      placeholder: "Rechercher un rôle…",
                      class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    }, null, 512), [
                      [_vModelText, recherche.value]
                    ])
                  ]),
                  _createElementVNode("ul", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rolesFiltres.value, (r) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: r.id
                      }, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (choisir(r.id)),
                          class: _normalizeClass(['w-full text-left px-4 py-3 hover:bg-gray-50',
                  r.id === selectionId.value ? 'bg-[#22282F]/5 border-l-4 border-[#22282F]' : 'border-l-4 border-transparent'])
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(r.nom), 1),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(r.nb_utilisateurs) + " util.", 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(r.code), 1),
                          _createElementVNode("div", _hoisted_16, " rang " + _toDisplayString(r.rang_circuit ?? '—') + " · " + _toDisplayString(r.nb_capacites) + " capacité(s) · " + _toDisplayString(r.nb_etapes_circuit) + " étape(s) ", 1)
                        ], 10, _hoisted_11)
                      ]))
                    }), 128)),
                    (rolesFiltres.value.length === 0)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_17, "Aucun rôle."))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (brouillon.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("h2", _hoisted_21, _toDisplayString(brouillon.value.nom || '(sans nom)'), 1),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(brouillon.value.code), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(onglets, (o) => {
                            return _createElementVNode("button", {
                              key: o.id,
                              onClick: ($event: any) => (onglet.value = o.id),
                              class: _normalizeClass(['px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors',
                  onglet.value === o.id ? 'border-[#22282F] text-[#22282F]' : 'border-transparent text-gray-500 hover:text-gray-800'])
                            }, _toDisplayString(o.label), 11, _hoisted_24)
                          }), 64))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        (onglet.value === 'general')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 mb-1" }, "Nom affiché", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((brouillon.value.nom) = $event)),
                                    disabled: !canEdit.value,
                                    class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm disabled:bg-gray-50"
                                  }, null, 8, _hoisted_29), [
                                    [_vModelText, brouillon.value.nom]
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 mb-1" }, "Niveau hiérarchique", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((brouillon.value.niveau_hierarchique) = $event)),
                                    type: "number",
                                    disabled: !canEdit.value,
                                    class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm disabled:bg-gray-50"
                                  }, null, 8, _hoisted_30), [
                                    [
                                      _vModelText,
                                      brouillon.value.niveau_hierarchique,
                                      void 0,
                                      { number: true }
                                    ]
                                  ]),
                                  _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-xs text-gray-400 mt-1" }, "1 = sommet. Sert à trier et à l'affichage.", -1))
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 mb-1" }, "Rang dans les circuits", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((brouillon.value.rang_circuit) = $event)),
                                    type: "number",
                                    disabled: !canEdit.value,
                                    placeholder: "(aucun)",
                                    class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm disabled:bg-gray-50"
                                  }, null, 8, _hoisted_31), [
                                    [
                                      _vModelText,
                                      brouillon.value.rang_circuit,
                                      void 0,
                                      { number: true }
                                    ]
                                  ]),
                                  _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-xs text-gray-400 mt-1" }, " Plus grand = plus haut. Agent 0, Chef de Service 20, Directeur 40 : entre Agent et Chef de Service, prenez 15. ", -1))
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 mb-1" }, "Description", -1)),
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((brouillon.value.description) = $event)),
                                    rows: "2",
                                    disabled: !canEdit.value,
                                    class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm disabled:bg-gray-50"
                                  }, null, 8, _hoisted_33), [
                                    [_vModelText, brouillon.value.description]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-700 mb-2" }, "Droits particuliers", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(catalogue.drapeaux, (d) => {
                                  return (_openBlock(), _createElementBlock("label", {
                                    key: d.key,
                                    class: "flex items-start gap-3 py-2 cursor-pointer"
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": ($event: any) => ((brouillon.value.drapeaux[d.key]) = $event),
                                      disabled: !canEdit.value,
                                      class: "mt-1 w-4 h-4"
                                    }, null, 8, _hoisted_34), [
                                      [_vModelCheckbox, brouillon.value.drapeaux[d.key]]
                                    ]),
                                    _createElementVNode("span", null, [
                                      _createElementVNode("span", _hoisted_35, _toDisplayString(d.label), 1),
                                      _createElementVNode("span", _hoisted_36, _toDisplayString(d.description), 1)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (onglet.value === 'capacites')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("p", _hoisted_38, [
                                  _createVNode(_unref(Info), { class: "w-4 h-4 mt-0.5 shrink-0 text-gray-400" }),
                                  _cache[23] || (_cache[23] = _createTextVNode(" Un rôle sans capacité n'a aucun de ces droits. ")),
                                  _cache[24] || (_cache[24] = _createElementVNode("strong", null, "Serveur", -1)),
                                  _cache[25] || (_cache[25] = _createTextVNode(" : le serveur refuse l'action sans la capacité. ")),
                                  _cache[26] || (_cache[26] = _createElementVNode("strong", null, "Interface", -1)),
                                  _cache[27] || (_cache[27] = _createTextVNode(" : ne fait que montrer ou cacher une page ou un bouton. "))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupes.value, (groupe) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: groupe.categorie
                                  }, [
                                    _createElementVNode("h3", _hoisted_39, _toDisplayString(groupe.categorie), 1),
                                    _createElementVNode("div", _hoisted_40, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupe.capacites, (c) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: c.key,
                                          class: "flex flex-wrap items-center gap-3 px-3 py-2.5"
                                        }, [
                                          _createElementVNode("input", {
                                            type: "checkbox",
                                            checked: c.key in brouillon.value.capacites,
                                            disabled: !canEdit.value,
                                            onChange: ($event: any) => (basculerCapacite(c.key, ($event.target as HTMLInputElement).checked)),
                                            class: "w-4 h-4"
                                          }, null, 40, _hoisted_41),
                                          _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, _toDisplayString(c.label), 1),
                                            _createElementVNode("div", _hoisted_44, _toDisplayString(c.description), 1)
                                          ]),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(['text-[11px] font-semibold px-2 py-0.5 rounded-full',
                      c.portee === 'serveur' ? 'bg-red-50 text-red-700' : 'bg-gray-100 text-gray-600'])
                                          }, _toDisplayString(c.portee === 'serveur' ? 'Serveur' : 'Interface'), 3),
                                          (c.key in brouillon.value.capacites)
                                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                key: 0,
                                                "onUpdate:modelValue": ($event: any) => ((brouillon.value.capacites[c.key]) = $event),
                                                disabled: !canEdit.value,
                                                class: "border border-gray-300 rounded-lg px-2 py-1 text-xs max-w-[16rem]"
                                              }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(catalogue.conditions, (o) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    key: o.value,
                                                    value: o.value
                                                  }, _toDisplayString(o.label), 9, _hoisted_46))
                                                }), 128))
                                              ], 8, _hoisted_45)), [
                                                [_vModelSelect, brouillon.value.capacites[c.key]]
                                              ])
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : (onglet.value === 'circuit')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  (brouillon.value.circuit_historique)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                                        _createVNode(_unref(AlertTriangle), { class: "w-4 h-4 mt-0.5 shrink-0" }),
                                        _cache[28] || (_cache[28] = _createTextVNode(" Le circuit de ce rôle est écrit dans le code : ce qui est saisi ici est ignoré. Seuls les rôles absents des circuits historiques (Agent, Chef de Service, Chef de Département, Directeur, Assistant SGA, SGA, CT) sont lus en base. "))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", _hoisted_49, [
                                    _createVNode(_unref(Info), { class: "w-4 h-4 mt-0.5 shrink-0 text-gray-400" }),
                                    _cache[29] || (_cache[29] = _createTextVNode(" Étapes que traverse une note rédigée par ce rôle, dans l'ordre. Sans étape, la note va directement au SG. "))
                                  ]),
                                  (brouillon.value.circuit.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                        _createElementVNode("table", _hoisted_51, [
                                          _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", { class: "bg-gray-50 text-left text-gray-500 text-xs uppercase tracking-wide" }, [
                                              _createElementVNode("th", { class: "px-3 py-2 w-16" }, "Ordre"),
                                              _createElementVNode("th", { class: "px-3 py-2" }, "Rôle qui valide"),
                                              _createElementVNode("th", { class: "px-3 py-2" }, "Périmètre"),
                                              _createElementVNode("th", { class: "px-3 py-2 text-center" }, "Paraphe"),
                                              _createElementVNode("th", { class: "px-3 py-2 text-center" }, "Signature"),
                                              _createElementVNode("th", { class: "px-3 py-2" }, "Libellé"),
                                              _createElementVNode("th", { class: "px-3 py-2 w-28" })
                                            ])
                                          ], -1)),
                                          _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brouillon.value.circuit, (e, i) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: i,
                                                class: "border-t border-gray-100 align-middle"
                                              }, [
                                                _createElementVNode("td", _hoisted_52, _toDisplayString(i + 1), 1),
                                                _createElementVNode("td", _hoisted_53, [
                                                  _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": ($event: any) => ((e.step_role_id) = $event),
                                                    disabled: !canEdit.value,
                                                    class: "border border-gray-300 rounded-lg px-2 py-1 text-sm"
                                                  }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (r) => {
                                                      return (_openBlock(), _createElementBlock("option", {
                                                        key: r.id,
                                                        value: r.id
                                                      }, _toDisplayString(r.nom), 9, _hoisted_55))
                                                    }), 128))
                                                  ], 8, _hoisted_54), [
                                                    [
                                                      _vModelSelect,
                                                      e.step_role_id,
                                                      void 0,
                                                      { number: true }
                                                    ]
                                                  ])
                                                ]),
                                                _createElementVNode("td", _hoisted_56, [
                                                  _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": ($event: any) => ((e.scope) = $event),
                                                    disabled: !canEdit.value,
                                                    class: "border border-gray-300 rounded-lg px-2 py-1 text-sm"
                                                  }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(catalogue.scopes, (s) => {
                                                      return (_openBlock(), _createElementBlock("option", {
                                                        key: s.value,
                                                        value: s.value
                                                      }, _toDisplayString(s.label), 9, _hoisted_58))
                                                    }), 128))
                                                  ], 8, _hoisted_57), [
                                                    [_vModelSelect, e.scope]
                                                  ])
                                                ]),
                                                _createElementVNode("td", _hoisted_59, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": ($event: any) => ((e.requires_paraphe) = $event),
                                                    disabled: !canEdit.value,
                                                    class: "w-4 h-4"
                                                  }, null, 8, _hoisted_60), [
                                                    [_vModelCheckbox, e.requires_paraphe]
                                                  ])
                                                ]),
                                                _createElementVNode("td", _hoisted_61, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": ($event: any) => ((e.requires_signature) = $event),
                                                    disabled: !canEdit.value,
                                                    class: "w-4 h-4"
                                                  }, null, 8, _hoisted_62), [
                                                    [_vModelCheckbox, e.requires_signature]
                                                  ])
                                                ]),
                                                _createElementVNode("td", _hoisted_63, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event: any) => ((e.label) = $event),
                                                    disabled: !canEdit.value,
                                                    maxlength: "60",
                                                    placeholder: "(nom du rôle)",
                                                    class: "border border-gray-300 rounded-lg px-2 py-1 text-sm w-36"
                                                  }, null, 8, _hoisted_64), [
                                                    [_vModelText, e.label]
                                                  ])
                                                ]),
                                                _createElementVNode("td", _hoisted_65, [
                                                  (canEdit.value)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createElementVNode("button", {
                                                          onClick: ($event: any) => (deplacer(i, -1)),
                                                          disabled: i === 0,
                                                          class: "p-1 text-gray-500 hover:text-gray-900 disabled:opacity-30",
                                                          title: "Monter"
                                                        }, [
                                                          _createVNode(_unref(ArrowUp), { class: "w-4 h-4" })
                                                        ], 8, _hoisted_66),
                                                        _createElementVNode("button", {
                                                          onClick: ($event: any) => (deplacer(i, 1)),
                                                          disabled: i === brouillon.value.circuit.length - 1,
                                                          class: "p-1 text-gray-500 hover:text-gray-900 disabled:opacity-30",
                                                          title: "Descendre"
                                                        }, [
                                                          _createVNode(_unref(ArrowDown), { class: "w-4 h-4" })
                                                        ], 8, _hoisted_67),
                                                        _createElementVNode("button", {
                                                          onClick: ($event: any) => (brouillon.value.circuit.splice(i, 1)),
                                                          class: "p-1 text-red-500 hover:text-red-700",
                                                          title: "Retirer"
                                                        }, [
                                                          _createVNode(_unref(Trash2), { class: "w-4 h-4" })
                                                        ], 8, _hoisted_68)
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_69, "Aucune étape.")),
                                  (canEdit.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                        _createElementVNode("button", {
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => (ajouterEtape('self'))),
                                          class: "px-3 py-1.5 border border-gray-300 rounded-lg text-sm hover:bg-gray-50"
                                        }, "+ Étape de l'auteur"),
                                        _createElementVNode("button", {
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (ajouterEtape('service'))),
                                          class: "px-3 py-1.5 border border-gray-300 rounded-lg text-sm hover:bg-gray-50"
                                        }, "+ Étape du service"),
                                        _createElementVNode("button", {
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (ajouterEtape('national'))),
                                          class: "px-3 py-1.5 border border-gray-300 rounded-lg text-sm hover:bg-gray-50"
                                        }, "+ Étape nationale")
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                  _createElementVNode("p", _hoisted_72, [
                                    _createVNode(_unref(Eye), { class: "w-4 h-4 mt-0.5 shrink-0 text-gray-400" }),
                                    _cache[31] || (_cache[31] = _createTextVNode(" Ce que verrait un titulaire de ce rôle, selon son rattachement. L'aperçu reflète le dernier enregistrement. "))
                                  ]),
                                  _createElementVNode("div", _hoisted_73, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apercuCartes.value, (a) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: a.cle,
                                        class: "border border-gray-200 rounded-lg p-4"
                                      }, [
                                        _createElementVNode("h3", _hoisted_74, _toDisplayString(a.titre), 1),
                                        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "text-xs font-bold uppercase tracking-wide text-gray-400 mb-1" }, "Menu", -1)),
                                        _createElementVNode("ul", _hoisted_75, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(a.pages, (p) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                              key: p.key
                                            }, "· " + _toDisplayString(p.label.replace('Page : ', '')), 1))
                                          }), 128)),
                                          (!a.pages.length)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_76, "Aucune page"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "text-xs font-bold uppercase tracking-wide text-gray-400 mb-1" }, "Droits", -1)),
                                        _createElementVNode("ul", _hoisted_77, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(a.capacites, (c) => {
                                            return (_openBlock(), _createElementBlock("li", { key: c }, "· " + _toDisplayString(libelle(c)), 1))
                                          }), 128)),
                                          (!a.capacites.length)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_78, "Aucun droit particulier"))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                      ]),
                      (canEdit.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                            _createElementVNode("button", {
                              onClick: enregistrer,
                              disabled: enregistrement.value || !modifie.value,
                              class: "px-5 py-2 bg-[#22282F] text-white rounded-lg text-sm hover:opacity-90 disabled:opacity-40"
                            }, _toDisplayString(enregistrement.value ? 'Enregistrement…' : 'Enregistrer'), 9, _hoisted_80),
                            (modifie.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_81, "Modifications non enregistrées"))
                              : _createCommentVNode("", true),
                            (message.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_82, [
                                  _createVNode(_unref(Check), { class: "w-4 h-4" }),
                                  _createTextVNode(" " + _toDisplayString(message.value), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (erreur.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(erreur.value), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("section", _hoisted_84, " Choisissez un rôle dans la liste. "))
              ])),
        (creation.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: "fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4",
              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (creation.value = null), ["self"]))
            }, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(creer, ["prevent"]),
                class: "bg-white rounded-xl shadow-xl w-full max-w-md p-6 space-y-4"
              }, [
                _cache[40] || (_cache[40] = _createElementVNode("h2", { class: "text-lg font-bold text-gray-900" }, "Nouveau rôle", -1)),
                _createElementVNode("div", null, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 mb-1" }, "Code", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((creation.value.code) = $event)),
                    required: "",
                    placeholder: "CHEF_DIVISION",
                    maxlength: "20",
                    class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono uppercase"
                  }, null, 512), [
                    [_vModelText, creation.value.code]
                  ]),
                  _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-xs text-gray-400 mt-1" }, "MAJUSCULES, chiffres, tirets bas. Définitif : il ne pourra plus être changé.", -1))
                ]),
                _createElementVNode("div", null, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 mb-1" }, "Nom affiché", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((creation.value.nom) = $event)),
                    required: "",
                    maxlength: "100",
                    class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                  }, null, 512), [
                    [_vModelText, creation.value.nom]
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", null, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 mb-1" }, "Niveau", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((creation.value.niveau_hierarchique) = $event)),
                      required: "",
                      type: "number",
                      class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    }, null, 512), [
                      [
                        _vModelText,
                        creation.value.niveau_hierarchique,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 mb-1" }, "Rang (circuits)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((creation.value.rang_circuit) = $event)),
                      type: "number",
                      placeholder: "(aucun)",
                      class: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    }, null, 512), [
                      [
                        _vModelText,
                        creation.value.rang_circuit,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ]),
                (erreurCreation.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(erreurCreation.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (creation.value = null)),
                    class: "px-4 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50"
                  }, "Annuler"),
                  _cache[39] || (_cache[39] = _createElementVNode("button", {
                    type: "submit",
                    class: "px-4 py-2 bg-[#22282F] text-white rounded-lg text-sm hover:opacity-90"
                  }, "Créer", -1))
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})